import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { BaseComponent } from 'src/app/models/base-component';
import { CampeonatosService } from '../../services/campeonatos/campeonatos.service';
import { Util } from 'src/app/utils/utils';
import { GlobalVariable } from 'src/app/global';
import { RolesPartidosService } from '../../services/roles-partidos/roles-partidos.service';
import * as fs from 'file-saver';
import { OrderPipe } from 'ngx-order-pipe';
import * as CryptoJS from 'crypto-js';
import { RegistroJugadorComponent } from '../registro-jugador/registro-jugador.component';
import { NgbModalRef } from 'node_modules/@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PopupConfirmacionComponent } from 'src/app/base/components/popup-confirmacion/popup-confirmacion.component';
import { TarjetasJugadorComponent } from '../tarjetas-jugador/tarjetas-jugador.component';

declare const PDFDocument:any;
declare const blobStream:any;
declare const qr:any

@Component({
    selector: 'app-club',
    templateUrl: './club.component.html',
    styleUrls: ['./club.component.css'],
    standalone: false
})
export class ClubComponent extends BaseComponent implements OnInit {

  id_cliente:any;
  cliente:any;
  partidos:any=[];
  detalles_ventas_pendientes:any=[];
  historial_pagos:any=[];
  grupos_pagos:any=[];
  pendientes_seleccionado:boolean=false;
  total_deuda:any=0;
  total_pagado:any=0;
  equipo_tab:any={};
  /* Medidas de la imagen de partidos de la semana: 1200x1200, que es la publicacion cuadrada que
     Facebook muestra sin recortar. Si los partidos no entran, salen en varias imagenes. */
  ancho_imagen_semana:number=1200;
  alto_imagen_semana:number=1200;
  cabecera_imagen_semana:number=210;
  /* Si los partidos no entran en el cuadrado, la imagen se estira hasta este alto antes de
     partirse en varias: una sola imagen siempre es mejor que dos descargas. */
  alto_maximo_imagen_semana:number=2400;
  //aire entre una tarjeta y la siguiente
  separacion_imagen_semana:number=26;
  /* Cuanto se aclara el color del campeonato para el fondo de las tarjetas: 0 lo deja tal cual y
     1 lo vuelve blanco. Con 0.88 queda un tono suave del color, no un blanco ajeno a la paleta. */
  aclarado_tarjeta_imagen:number=0.88;
  modalJugador:NgbModalRef;
  modal_impresion_tarjetas_jugador:NgbModalRef;

  constructor(private _Activatedroute:ActivatedRoute,
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    public campeonatoService:CampeonatosService,
  public rolesPartidosService:RolesPartidosService,
  private toastr: ToastrService,
  private orderPipe: OrderPipe) {
      super(persistenciaService,modalService,generalService,usuarioService);
  }

  async ngOnInit(): Promise<void> {
    this.id_cliente=CryptoJS.AES.decrypt(this._Activatedroute.snapshot.paramMap.get("id_cliente").toString().replaceAll('Por21Ld', '/'), GlobalVariable.Dictionary.TIPO_RECURSOS_MULTIMEDIA).toString(CryptoJS.enc.Utf8);
    await this.obtenerEquiposCliente(this.id_cliente);
    await this.establecerEquipoTab(this.cliente.equipos[0]);

  }

  establecerEquipoTab(equipo){
    this.equipo_tab=equipo;
    this.obtenerPartidosEquipo();
    this.pendientes_seleccionado=false;
  }

  async obtenerEquiposCliente(id_cliente){
    this.blockUI.start();
    this.cliente=await this.campeonatoService.obtenerClienteEquipos(id_cliente).toPromise();
    for(let i=0;i<this.cliente.equipos.length;i++){
      this.cliente.equipos[i].jugadores=this.orderPipe.transform(this.cliente.equipos[i].jugadores, 'persona.nombre_completo',false);
    }
    this.blockUI.stop();
  }

  async obtenerPartidosEquipo(){
    this.blockUI.start();
    this.partidos=await this.campeonatoService.obtenerPartidosEquipo(this.equipo_tab.id).toPromise();
    this.blockUI.stop();
  }

  async generarListaConvocados(jugadores,partido){
    this.blockUI.start();
    let doc = new PDFDocument({size:[612, 612],margin:10});
    let stream = doc.pipe(blobStream());
    let fondo=await Util.convertirUrlToBase64Image(this.rest_server+"img/fondo-rol-partido.png");
    await this.dibujarCabeceraPartido(doc,fondo,this.equipo_tab.campeonato,partido.rol_partido);
    
    let y_doc=jugadores.length>0?90:180;
    let logo_equipo_1=await Util.convertirUrlToBase64Image(this.rest_server+partido.equipo_1.logo);
    let logo_equipo_2=await Util.convertirUrlToBase64Image(this.rest_server+partido.equipo_2.logo);
    doc.image(logo_equipo_1,45,y_doc, { width: 150, height: 150}); 
    doc.image(logo_equipo_2,415,y_doc, { width: 150, height: 150}); 

    doc.font('Helvetica-Bold',40);
    doc.fillColor(this.equipo_tab.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta);
    doc.text("VS",0,y_doc+30,{width:612,align:"center"});
    doc.roundedRect(201,y_doc+60,210,90,5).fill(this.equipo_tab.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta).stroke();;
    doc.font('Helvetica-Bold',20);
    let fecha_hora=new Date(partido.fecha_hora);
    doc.fillColor(this.equipo_tab.campeonato.configuracion_tarjeta_jugador.enunciados_color);
    doc.text(fecha_hora.toLocaleDateString("es-ES", { weekday: 'long' }).toUpperCase(),0,y_doc+70,{width:612,align:"center"});
    doc.text(fecha_hora.getDate()+" "+fecha_hora.toLocaleString('es-ES', { month: 'long' }).toUpperCase()+" "+fecha_hora.getFullYear(),0,y_doc+90,{width:612,align:"center"});
    doc.text(fecha_hora.getHours()+":"+fecha_hora.getMinutes(),0,y_doc+110,{width:612,align:"center"});
    doc.text(this.equipo_tab.categoria.nombre,0,y_doc+130,{width:612,align:"center"});

    doc.font('Helvetica-Bold',13);
    doc.fillColor(this.equipo_tab.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta);
    doc.text(partido.equipo_1.nombre,30,y_doc+210,{width:200,align:"center"});
    doc.text(partido.equipo_2.nombre,382,y_doc+210,{width:200,align:"center"});

    let y_jugador=360;
    if(jugadores.length>0){
      doc.font('Helvetica-Bold',20);
      doc.roundedRect(156,335,300,23,5).fill(this.equipo_tab.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta).stroke();;
      doc.fillColor(this.equipo_tab.campeonato.configuracion_tarjeta_jugador.enunciados_color);
      doc.text("LISTA DE CONVOCADOS",0,340,{width:612,align:"center"});
      
      doc.fillColor(this.equipo_tab.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta);
      doc.font('Helvetica-Bold',15);
     jugadores=this.orderPipe.transform(jugadores, 'jugador.persona.nombre_completo',false);
      for(let i=0;i<jugadores.length;i++){
        doc.text((i+1)+".- "+jugadores[i].jugador.persona.nombre_completo,150,y_jugador,{width:400,align:"left"});
        y_jugador=y_jugador+15;
      }
    }

    doc.font('Helvetica-Bold',12);
    doc.rect(0,550,GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA[0],80).fill(this.equipo_tab.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta).stroke();
    doc.fillColor(this.equipo_tab.campeonato.configuracion_tarjeta_jugador.enunciados_color);
    doc.text("ESCENARIO:",20,560,{width:572,align:"center"});
    doc.text(partido.escenario.nombre.toUpperCase()+" - "+(partido.escenario.direccion?partido.escenario.direccion.toUpperCase():""),20,572,{width:572,align:"center"});

    doc.end();
    let me=this;
    stream.on('finish', async function(d) {
      var reader = new FileReader();
      reader.readAsDataURL(stream.toBlob('application/pdf')); 
      reader.onloadend = async function() {
        var base64data = reader.result;                
        me.rolesPartidosService.convertirPdfImg({base64:base64data,nombre:"rol-partidos.png"}).subscribe(async (res:any)=>{
          fs.saveAs(GlobalVariable.SERVER_URL+res.path, "rol-partidos.png");
          me.blockUI.stop();
        });
      }
      /*var fileURL = stream.toBlobURL('application/pdf');
      window.open(fileURL,'_blank','location=no');*/
    });
  }

  async dibujarCabeceraPartido(doc,fondo,campeonato,rol_partido){
    doc.image(fondo,0,0, { width: GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA[0], height: GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA[1],align:'right' });
    doc.rect(0,0,GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA[0],80).fill(campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta).stroke();
    let logo=await Util.convertirUrlToBase64Image(this.rest_server+campeonato.logo);
    let logo_empresa=await Util.convertirUrlToBase64Image(this.rest_server+this.cliente.empresa.imagen);
    doc.image(logo_empresa,20,5, { width: 70, height: 70,align:'left' }); 
    doc.fillColor(campeonato.configuracion_tarjeta_jugador.enunciados_color);
    doc.font('Times-Bold',30);
    doc.text(campeonato.nombre.toUpperCase(),0,20,{align:"center"});
    doc.font('Times-Bold',15);
    doc.text(rol_partido.rol.nombre,0,50,{align:"center"});
    doc.image(logo,522,5, { width: 70, height: 70,align:'right' });
    doc.font('Helvetica-Bold',16);
  }

  /* Partidos de todo el club en los proximos siete dias. Se juntan los de todos sus equipos, sin
     repetir los que enfrentan a dos equipos del mismo club, que vienen por los dos lados. */
  async obtenerPartidosSemanaClub(){
    let desde=new Date();
    desde.setHours(0,0,0,0);
    let hasta=new Date(desde.getTime());
    hasta.setDate(hasta.getDate()+7);

    let vistos={},partidos=[];
    for(let i=0;i<this.cliente.equipos.length;i++){
      let equipo=this.cliente.equipos[i];
      let suyos:any=await this.campeonatoService.obtenerPartidosEquipo(equipo.id).toPromise();
      for(let j=0;j<suyos.length;j++){
        let partido=suyos[j];
        let fecha=new Date(partido.fecha_hora);
        if(fecha>=desde && fecha<hasta && !vistos[partido.id]){
          vistos[partido.id]=true;
          //la categoria con la que participa el club en ese partido
          partido.categoria_club=equipo.categoria;
          partidos.push(partido);
        }
      }
    }
    /* Orden: por hora y, entre los que empiezan a la misma, por cancha. Cada partido lleva escrita
       su cancha, asi que la lista se lee de corrido como el dia que se va a jugar. */
    partidos.sort(function(uno,otro){
      let momento_uno=new Date(uno.fecha_hora).getTime(),momento_otro=new Date(otro.fecha_hora).getTime();
      if(momento_uno!=momento_otro){
        return momento_uno-momento_otro;
      }
      let cancha_uno=uno.escenario?uno.escenario.nombre:"",cancha_otro=otro.escenario?otro.escenario.nombre:"";
      return cancha_uno.localeCompare(cancha_otro);
    });
    return partidos;
  }

  fechaLiteralClub(fecha){
    return fecha.toLocaleDateString("es-ES",{weekday:'long'}).toUpperCase()+" "+fecha.getDate()+
           " DE "+fecha.toLocaleString('es-ES',{month:'long'}).toUpperCase();
  }

  /* Paleta del campeonato. La que guarda en configuracion_tarjeta_jugador esta pensada para el
     carnet, o sea sobre fondo oscuro: el titulo y los datos suelen ser claros. La imagen usa esos
     colores tal cual en las bandas oscuras, y sobre las tarjetas blancas los pasa por
     colorLegibleSobreBlanco, que oscurece lo necesario para que se lean. */
  paletaCampeonato(campeonato){
    let configuracion=(campeonato && campeonato.configuracion_tarjeta_jugador)?
                       campeonato.configuracion_tarjeta_jugador:{};
    let valor=function(color,defecto){ return (color && String(color).charAt(0)=="#")?color:defecto; };
    let fondo=valor(configuracion.fondo_color_tarjeta,"#06427e");
    let datos=valor(configuracion.datos_color,"#ffff00");
    //la tarjeta es el propio color del campeonato aclarado, no un blanco ajeno a la paleta
    let tarjeta=this.mezclarConBlanco(fondo,this.aclarado_tarjeta_imagen);
    return {
      fondo_color_tarjeta:fondo,
      enunciados_color:valor(configuracion.enunciados_color,"#ffffff"),
      datos_color:datos,
      titulo_color_liga:valor(configuracion.titulo_color_liga,valor(configuracion.enunciados_color,"#ffffff")),
      tarjeta:tarjeta,
      //los mismos colores, ya acomodados para escribir sobre esa tarjeta
      sobre_tarjeta:this.colorLegibleSobre(fondo,tarjeta),
      dato_sobre_tarjeta:this.colorLegibleSobre(datos,tarjeta)
    };
  }

  //mezcla el color con blanco: 0 lo deja igual, 1 lo vuelve blanco
  mezclarConBlanco(color,proporcion){
    let canales=this.canalesColor(color);
    if(!canales){
      return "#ffffff";
    }
    return this.colorDeCanales(canales.map(canal => canal+(255-canal)*proporcion));
  }

  /* Oscurece el color manteniendo el tono hasta que se lea sobre el fondo indicado (4.5:1). El
     amarillo de datos_color, por ejemplo, sobre una tarjeta clara no se veria. */
  colorLegibleSobre(color,fondo){
    let canales=this.canalesColor(color);
    if(!canales){
      return "#1a1a1a";
    }
    let factor=1;
    while(factor>0.15 && this.contrasteEntre(this.colorDeCanales(canales.map(c => c*factor)),fondo)<4.5){
      factor=factor-0.05;
    }
    return this.colorDeCanales(canales.map(canal => canal*factor));
  }

  canalesColor(color){
    let canales=[1,3,5].map(i => parseInt(String(color).substr(i,2),16));
    return canales.some(canal => isNaN(canal))?null:canales;
  }

  colorDeCanales(canales){
    return "#"+canales.map(canal => {
      let valor=Math.max(0,Math.min(255,Math.round(canal)));
      return (valor<16?"0":"")+valor.toString(16);
    }).join("");
  }

  luminanciaColor(color){
    let canales=this.canalesColor(color);
    if(!canales){
      return 1;
    }
    let lineales=canales.map(canal => canal/255)
                        .map(valor => (valor<=0.04045)?(valor/12.92):Math.pow((valor+0.055)/1.055,2.4));
    return 0.2126*lineales[0]+0.7152*lineales[1]+0.0722*lineales[2];
  }

  contrasteEntre(uno,otro){
    let luz=this.luminanciaColor(uno),sombra=this.luminanciaColor(otro);
    return (Math.max(luz,sombra)+0.05)/(Math.min(luz,sombra)+0.05);
  }

  //los equipos del club se dibujan con el escudo mas grande que el del rival
  esEquipoDelClub(equipo){
    return !!(equipo && this.cliente.equipos.some(propio => propio.id==equipo.id));
  }

  /* Los escudos se piden una sola vez por equipo: un mismo equipo aparece en varios partidos de la
     semana. Si alguno falla, se devuelve null y esa fila sale sin escudo, sin cortar la imagen. */
  async logoEquipoImagen(equipo,cache){
    if(!equipo || !equipo.logo){
      return null;
    }
    if(cache[equipo.logo]===undefined){
      try{
        cache[equipo.logo]=await Util.convertirUrlToBase64Image(this.rest_server+equipo.logo);
      }catch(error){
        cache[equipo.logo]=null;
      }
    }
    return cache[equipo.logo];
  }

  /* Cabecera de la imagen: se repite en cada pagina cuando los partidos no entran en una sola. */
  async dibujarCabeceraImagenSemana(doc,fondo,colores,logos){
    let ancho=this.ancho_imagen_semana;
    if(fondo){
      doc.image(fondo,0,0,{ width:ancho, height:this.alto_imagen_semana });
    }
    doc.rect(0,0,ancho,this.cabecera_imagen_semana).fill(colores.fondo_color_tarjeta).stroke();

    if(logos.club){
      doc.image(logos.club,40,40,{ width:130, height:130 });
    }
    if(logos.campeonato){
      doc.image(logos.campeonato,ancho-170,40,{ width:130, height:130 });
    }

    //el nombre del club con el color de titulo del campeonato; el subtitulo con el de enunciados
    doc.fillColor(colores.titulo_color_liga);
    doc.font('Helvetica-Bold',46);
    doc.text(String(this.cliente.identificacion).toUpperCase(),190,62,{ width:ancho-380, align:"center" });
    doc.fillColor(colores.enunciados_color);
    doc.font('Helvetica-Bold',26);
    doc.text("PARTIDOS DE LA SEMANA",190,128,{ width:ancho-380, align:"center" });
  }

  /* Una fila: hora, los dos equipos con su escudo y, abajo, categoria y cancha. Se respeta el
     orden del fixture (local primero) y el escudo del equipo del club va mas grande, asi se ve de
     un vistazo cual es el propio y si juega de local o de visitante. */
  async dibujarPartidoImagenSemana(doc,partido,fecha,y,alto_tarjeta,colores,cache_logos){
    let ancho=this.ancho_imagen_semana;
    let centro_y=y+(alto_tarjeta/2);
    let centro_x=ancho/2;

    doc.roundedRect(30,y,ancho-60,alto_tarjeta,10).fill(colores.tarjeta).stroke();

    doc.fillColor(colores.sobre_tarjeta);
    doc.font('Helvetica-Bold',36);
    doc.text(this.horaTextoClub(fecha),54,centro_y-19,{ width:150 });

    let grande=Math.round(alto_tarjeta*0.74),chico=Math.round(alto_tarjeta*0.46);
    let propio_1=this.esEquipoDelClub(partido.equipo_1);
    let propio_2=this.esEquipoDelClub(partido.equipo_2);
    let lado_1=propio_1?grande:chico,lado_2=propio_2?grande:chico;

    let logo_1=await this.logoEquipoImagen(partido.equipo_1,cache_logos);
    let logo_2=await this.logoEquipoImagen(partido.equipo_2,cache_logos);
    if(logo_1){
      doc.image(logo_1,196,centro_y-(lado_1/2),{ width:lado_1, height:lado_1 });
    }
    if(logo_2){
      doc.image(logo_2,ancho-196-lado_2,centro_y-(lado_2/2),{ width:lado_2, height:lado_2 });
    }

    //el nombre del equipo propio va mas marcado que el del rival
    let x_nombre_1=196+lado_1+16;
    doc.fillColor(colores.sobre_tarjeta);
    doc.font(propio_1?'Helvetica-Bold':'Helvetica',propio_1?25:22);
    doc.text(partido.equipo_1.nombre,x_nombre_1,centro_y-24,
             { width:centro_x-x_nombre_1-34, align:"left", height:48, ellipsis:true });

    doc.fillColor(colores.dato_sobre_tarjeta);
    doc.font('Helvetica-Bold',24);
    doc.text("VS",centro_x-34,centro_y-26,{ width:68, align:"center" });

    let x_nombre_2=centro_x+34;
    let ancho_nombre_2=(ancho-196-lado_2-16)-x_nombre_2;
    doc.fillColor(colores.sobre_tarjeta);
    doc.font(propio_2?'Helvetica-Bold':'Helvetica',propio_2?25:22);
    doc.text(partido.equipo_2.nombre,x_nombre_2,centro_y-24,
             { width:ancho_nombre_2, align:"right", height:48, ellipsis:true });

    doc.fillColor(colores.dato_sobre_tarjeta);
    doc.font('Helvetica-Bold',17);
    doc.text((partido.categoria_club?partido.categoria_club.nombre:"")+
             (partido.escenario?("   ·   "+partido.escenario.nombre):""),
             196,y+alto_tarjeta-30,{ width:ancho-392, align:"center" });
  }

  /* Imagen para compartir con los partidos de la semana de todo el club: una fila por partido,
     agrupados por dia. Se arma como PDF y el servidor lo convierte a png, igual que el rol. */
  async generarImagenPartidosSemana(){
    this.blockUI.start('Armando la imagen... espere por favor!');
    let partidos=await this.obtenerPartidosSemanaClub();
    if(partidos.length==0){
      this.blockUI.stop();
      this.toastr.info("El club no tiene partidos programados para los próximos siete días.");
      return;
    }

    let ancho=this.ancho_imagen_semana;
    let alto_fecha=58,margen_inferior=40,alto_tarjeta_minimo=108;

    //cuantas franjas de fecha van, para repartir el alto que queda entre los partidos
    let fechas=[];
    for(let i=0;i<partidos.length;i++){
      let dia=new Date(partidos[i].fecha_hora).toDateString();
      if(fechas.indexOf(dia)<0){
        fechas.push(dia);
      }
    }

    /* La imagen es cuadrada mientras los partidos entren; si son muchos, se estira hacia abajo en
       vez de partirse en dos. Antes se partia desde el octavo partido y, como van ordenados por
       hora, la segunda imagen se quedaba con las canchas de la tarde: el navegador descarta esa
       segunda descarga y parecia que faltaban partidos. */
    /* Lo que ocupa todo lo que no son partidos: cabecera, el aire de arriba, una franja por fecha
       y el margen de abajo. Es la misma cuenta que sigue el dibujo, para que lo calculado y lo
       dibujado no se separen. */
    let fijo=this.cabecera_imagen_semana+this.separacion_imagen_semana+
             (fechas.length*alto_fecha)+margen_inferior;
    let alto_necesario=fijo+partidos.length*(alto_tarjeta_minimo+this.separacion_imagen_semana);
    let alto=Math.min(Math.max(this.alto_imagen_semana,alto_necesario),this.alto_maximo_imagen_semana);
    let tope=alto-margen_inferior;

    /* La separacion entre tarjetas es fija: primero se descuenta, y lo que queda es el alto de
       cada tarjeta. Asi el aire entre partidos no se achica cuando hay muchos. */
    let disponible=tope-this.cabecera_imagen_semana-this.separacion_imagen_semana-
                   (fechas.length*alto_fecha);
    let alto_fila=Math.floor(disponible/partidos.length);
    let alto_tarjeta=Math.max(alto_tarjeta_minimo,
                              Math.min(150,alto_fila-this.separacion_imagen_semana));
    alto_fila=alto_tarjeta+this.separacion_imagen_semana;

    let campeonato=this.cliente.equipos[0].campeonato;
    let colores=this.paletaCampeonato(campeonato);

    let cache_logos={};
    let logos={ club:await this.logoEquipoImagen(this.cliente.equipos[0],cache_logos),
                campeonato:null, fondo:null };
    try{
      logos.campeonato=await Util.convertirUrlToBase64Image(this.rest_server+campeonato.logo);
    }catch(error){ logos.campeonato=null; }
    try{
      logos.fondo=await Util.convertirUrlToBase64Image(this.rest_server+"img/fondo-rol-partido.png");
    }catch(error){ logos.fondo=null; }

    let doc=new PDFDocument({size:[ancho,alto],margin:0});
    let stream=doc.pipe(blobStream());
    await this.dibujarCabeceraImagenSemana(doc,logos.fondo,colores,logos);

    let y=this.cabecera_imagen_semana+this.separacion_imagen_semana,dia_dibujado="";
    for(let i=0;i<partidos.length;i++){
      let partido=partidos[i];
      let fecha=new Date(partido.fecha_hora);
      let cambia_dia=(fecha.toDateString()!=dia_dibujado);
      let necesario=alto_fila+(cambia_dia?alto_fecha:0);

      //si lo que viene no entra, sigue en otra imagen: el servidor devuelve una por pagina
      if(y+necesario>tope){
        doc.addPage({ size:[ancho,alto], margin:0 });
        await this.dibujarCabeceraImagenSemana(doc,logos.fondo,colores,logos);
        y=this.cabecera_imagen_semana+this.separacion_imagen_semana;
        dia_dibujado="";
        cambia_dia=true;
      }

      if(cambia_dia){
        dia_dibujado=fecha.toDateString();
        doc.rect(0,y,ancho,alto_fecha-14).fill(colores.fondo_color_tarjeta).stroke();
        doc.fillColor(colores.datos_color);
        doc.font('Helvetica-Bold',30);
        doc.text(this.fechaLiteralClub(fecha),0,y+7,{ width:ancho, align:"center" });
        y=y+alto_fecha;
      }

      await this.dibujarPartidoImagenSemana(doc,partido,fecha,y,alto_tarjeta,colores,cache_logos);
      y=y+alto_fila;
    }

    doc.end();
    let me=this;
    stream.on('finish',function(){
      var reader=new FileReader();
      reader.readAsDataURL(stream.toBlob('application/pdf'));
      reader.onloadend=async function(){
        var base64data=reader.result;
        me.rolesPartidosService.convertirPdfImg({ nombre:"partidos-semana.png", campeonato:campeonato,
                                                  base64:base64data }).subscribe(async (res:any)=>{
          let rutas=res.paths?res.paths:[res.path];
          for(let i=0;i<rutas.length;i++){
            //espaciadas, porque el navegador descarta las descargas simultaneas
            if(i>0){
              await new Promise(terminar => setTimeout(terminar,700));
            }
            fs.saveAs(GlobalVariable.SERVER_URL+rutas[i],rutas[i].split("/").pop());
          }
          /* Si igual salieron varias, se avisa: el navegador puede bloquear la segunda descarga y
             sin el aviso parece que faltaran partidos. */
          if(rutas.length>1){
            me.toastr.info("Los partidos no entraban en una sola imagen: se generaron "+rutas.length+
                           ". Si el navegador bloqueó alguna descarga, habilitala y volvé a intentar.");
          }
          me.blockUI.stop();
        });
      }
    });
  }

  horaTextoClub(fecha){
    let hora=fecha.getHours(),minuto=fecha.getMinutes();
    return (hora<10?"0":"")+hora+":"+(minuto<10?"0":"")+minuto;
  }

  async crearNuevoJugador(equipo){
    this.modalJugador = this.modalService.open(RegistroJugadorComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    this.modalJugador.componentInstance.equipo = equipo;
		this.modalJugador.componentInstance.usuario = {id_empresa:this.cliente.id_empresa};
		
		this.modalJugador.componentInstance.alTerminar.subscribe((res) => {
			if(res){
				if(res.tiene_error){
					this.toastr.error(res.mensaje);
					this.toastr.error(res.stack.substring(0,500));
				}else{
					this.obtenerEquiposCliente(this.id_cliente);
					this.modalJugador.close();
				}
			}else{
				this.modalJugador.close();
			}
			
		});
  }

  async modificarJugador(jugador_a_modificar){
    let jugador:any=jugador_a_modificar;
    jugador.persona.fecha_nacimiento_texto=jugador.persona.fecha_nacimiento?Util.convertirFechaAObjectoFecha(new Date(jugador.persona.fecha_nacimiento)):null;
    jugador.id_empresa=this.cliente.id_empresa;

    this.modalJugador = this.modalService.open(RegistroJugadorComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    this.modalJugador.componentInstance.jugador = jugador;
    this.modalJugador.componentInstance.equipo = this.equipo_tab;
		this.modalJugador.componentInstance.usuario = {id_empresa:this.cliente.id_empresa};
		
		this.modalJugador.componentInstance.alTerminar.subscribe((res) => {
			if(res){
				if(res.tiene_error){
					this.toastr.error(res.mensaje);
					this.toastr.error(res.stack.substring(0,500));
				}else{
					this.obtenerEquiposCliente(this.id_cliente);
					this.modalJugador.close();
				}
			}else{
				this.modalJugador.close();
			}
		});
  }

  abrirPopupConfirmacionEliminacionJugador(jugador){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro de eliminar al jugador?";
		this.popupConfirmacion.componentInstance.data = jugador;
		
		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){
				this.eliminarJugador($e.data);
			}
			this.popupConfirmacion.close();
        });
	}

  eliminarJugador(jugador){
		this.blockUI.start();
		this.campeonatoService.eliminarJugador(jugador).subscribe((dato:any)=>{
			this.blockUI.stop();
			if(dato.tiene_error){
				this.toastr.error(dato.mensaje);
			}else{
        this.obtenerEquiposCliente(this.id_cliente);
				this.toastr.success(dato.mensaje);
			}
		});
	}

 async verPendientesEconomicos(){
  this.pendientes_seleccionado=true;
  this.total_deuda=0;
  this.total_pagado=0;
  this.blockUI.start();
    this.detalles_ventas_pendientes=await this.rolesPartidosService.obtenerDetallesVentaPendientes(this.cliente.id).toPromise();
    for(let i=0;i<this.detalles_ventas_pendientes.length;i++){
      this.total_deuda=this.total_deuda+Number(this.detalles_ventas_pendientes[i].venta.saldo);
    }
    let pagos:any=await this.rolesPartidosService.obtenerHistorialPagos(this.cliente.id).toPromise();
    this.historial_pagos=Array.isArray(pagos)?pagos:[];
    for(let i=0;i<this.historial_pagos.length;i++){
      this.total_pagado=this.total_pagado+Number(this.historial_pagos[i].monto_pagado);
    }
    this.grupos_pagos=this.agruparPagosPorFecha(this.historial_pagos);
  this.blockUI.stop();
  }

  //agrupa los pagos por dia (el backend ya los manda del mas reciente al mas antiguo) y calcula la
  //sumatoria de cada fecha, para que el delegado vea de un vistazo cuanto pago cada dia.
  agruparPagosPorFecha(pagos){
    let grupos=[],indice={};
    for(let i=0;i<pagos.length;i++){
      let pago=pagos[i];
      let dia=pago.fecha?new Date(pago.fecha):null;
      let clave=dia?dia.getFullYear()+"-"+dia.getMonth()+"-"+dia.getDate():"sin-fecha";
      if(indice[clave]===undefined){
        indice[clave]=grupos.length;
        let texto="Sin fecha";
        if(dia){
          texto=dia.toLocaleDateString("es-ES",{weekday:'long',day:'numeric',month:'long',year:'numeric'});
          texto=texto.charAt(0).toUpperCase()+texto.slice(1);
        }
        grupos.push({ fecha:pago.fecha, fecha_texto:texto, total:0, pagos:[] });
      }
      let grupo=grupos[indice[clave]];
      grupo.pagos.push(pago);
      grupo.total=grupo.total+Number(pago.monto_pagado);
    }
    return grupos;
  }

  //concepto de un pago: el detalle de la venta que se pago (sus productos), sea un pago al contado
  //hecho en la misma venta o un pago a cuenta de una venta a credito anterior. Si la venta no trajo
  //detalle, se cae a la observacion del pago.
  conceptoPago(pago){
    let detalles=(pago.venta && pago.venta.detallesVenta)?pago.venta.detallesVenta:[];
    let conceptos=detalles.map(detalle => (detalle.producto?detalle.producto.nombre:"")+
      (detalle.descripcion?" "+detalle.descripcion:"")).filter(texto => texto.trim()!="");
    if(conceptos.length>0){
      return conceptos.join(", ");
    }
    return pago.observacion?pago.observacion:"Pago a cuenta";
  }

  //recibo PDF de los pagos de una fecha, para que el delegado lo descargue como comprobante. Lleva
  //el logo del campeonato y el nombre del torneo en la cabecera, y el detalle con la sumatoria del dia.
  async descargarReciboFecha(grupo){
    let campeonato=(this.cliente.equipos && this.cliente.equipos.length>0)?this.cliente.equipos[0].campeonato:null;
    if(!campeonato){
      this.toastr.error("No se pudo determinar el torneo para el recibo.");
      return;
    }
    this.blockUI.start('Generando recibo...');
    try{
      let colores=this.paletaCampeonato(campeonato);
      let doc=new PDFDocument({size:'A4',margin:40});
      let stream=doc.pipe(blobStream());
      let ancho=doc.page.width,alto=doc.page.height,margen=40,util=ancho-margen*2;
      let xForma=margen,xConcepto=margen+92,xMonto=ancho-margen-92;

      //cabecera: banda con el color del torneo, el logo del campeonato y el nombre del torneo
      doc.rect(0,0,ancho,108).fill(colores.fondo_color_tarjeta);
      try{
        let logo=await Util.convertirUrlToBase64Image(this.rest_server+campeonato.logo);
        doc.image(logo,margen,22,{fit:[64,64]});
      }catch(e){}
      doc.fillColor(colores.enunciados_color).font('Helvetica-Bold',19);
      doc.text((campeonato.nombre||'').toUpperCase(),margen+80,30,{width:util-80});
      doc.font('Helvetica-Bold',12).text('RECIBO DE PAGO',margen+80,64,{width:util-80});

      //datos del equipo, la fecha del pago y la emision
      let y=128;
      doc.fillColor('#333333').font('Helvetica',11);
      doc.text('Equipo: '+this.equiposDeGrupo(grupo),margen,y); y+=18;
      doc.text('Fecha del pago: '+grupo.fecha_texto,margen,y); y+=18;
      doc.text('Emitido: '+this.fechaEmisionRecibo(),margen,y); y+=26;

      //encabezado de la tabla
      doc.rect(margen,y,util,22).fill(colores.fondo_color_tarjeta);
      doc.fillColor(colores.enunciados_color).font('Helvetica-Bold',10);
      doc.text('FORMA',xForma+6,y+7);
      doc.text('CONCEPTO',xConcepto,y+7);
      doc.text('MONTO (Bs)',xMonto,y+7,{width:84,align:'right'});
      y+=22;

      //una fila por pago del dia
      for(let i=0;i<grupo.pagos.length;i++){
        let pago=grupo.pagos[i];
        let concepto=this.conceptoPago(pago);
        doc.font('Helvetica',10);
        let altoFila=Math.max(20,doc.heightOfString(concepto,{width:xMonto-xConcepto-10})+10);
        if(y+altoFila>alto-70){ doc.addPage(); y=50; }
        if(i%2==1){ doc.rect(margen,y,util,altoFila).fill('#f7f2ec'); }
        doc.font('Helvetica-Bold',8).fillColor('#8a5a1a').text((pago.forma_pago||'').toUpperCase(),xForma+6,y+6,{width:80});
        doc.font('Helvetica',10).fillColor('#333333').text(concepto,xConcepto,y+6,{width:xMonto-xConcepto-10});
        doc.font('Helvetica-Bold',10).text(Number(pago.monto_pagado).toFixed(2),xMonto,y+6,{width:84,align:'right'});
        y+=altoFila;
      }

      //sumatoria del dia
      y+=10;
      if(y+30>alto-40){ doc.addPage(); y=50; }
      doc.rect(margen,y,util,28).fill('#eaf7ee');
      doc.fillColor('#256b39').font('Helvetica-Bold',13);
      doc.text('TOTAL DEL DÍA',xConcepto,y+8);
      doc.text('Bs '+Number(grupo.total).toFixed(2),xMonto,y+8,{width:84,align:'right'});

      doc.end();
      let me=this;
      stream.on('finish',function(){
        fs.saveAs(stream.toBlob('application/pdf'),'recibo-'+me.nombreArchivoFecha(grupo)+'.pdf');
        me.blockUI.stop();
      });
    }catch(err){
      this.blockUI.stop();
      this.toastr.error("No se pudo generar el recibo.");
    }
  }

  fechaEmisionRecibo(){
    let hoy=new Date();
    return hoy.toLocaleDateString("es-ES",{day:'numeric',month:'long',year:'numeric'});
  }

  //nombre de archivo del recibo a partir de la fecha del grupo (aaaa-mm-dd)
  nombreArchivoFecha(grupo){
    let d=grupo.fecha?new Date(grupo.fecha):new Date();
    let mm=d.getMonth()+1,dd=d.getDate();
    return d.getFullYear()+"-"+(mm<10?"0":"")+mm+"-"+(dd<10?"0":"")+dd;
  }

  //equipo al que corresponde un pago: se lo ubica por la venta de inscripcion con la que se cobro
  //(cada equipo guarda id_venta_inscripcion). Devuelve "" si el pago no esta enlazado a un equipo.
  equipoDePago(pago){
    if(!pago.venta || !this.cliente.equipos){ return ""; }
    let equipo=this.cliente.equipos.find(equipo => equipo.id_venta_inscripcion==pago.venta.id);
    return equipo?equipo.nombre:"";
  }

  //nombre(s) del equipo cuyos pagos figuran en la fecha del recibo. Si un dia toca a varios equipos
  //se listan todos; si ningun pago esta enlazado a una inscripcion (ej. multas), se listan los
  //equipos del club, nunca el nombre del cliente.
  equiposDeGrupo(grupo){
    let nombres=[];
    for(let i=0;i<grupo.pagos.length;i++){
      let nombre=this.equipoDePago(grupo.pagos[i]);
      if(nombre && nombres.indexOf(nombre)<0){ nombres.push(nombre); }
    }
    if(nombres.length==0){
      nombres=(this.cliente.equipos||[]).map(equipo => equipo.nombre).filter(nombre => !!nombre);
    }
    return nombres.length>0?nombres.join(", "):"";
  }

  abrirModalGeneracionPdfTarjetasJugador(jugadores,equipo){
    this.modal_impresion_tarjetas_jugador = this.modalService.open(TarjetasJugadorComponent, {windowClass:'tarjetas-jugador',scrollable:true,ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
		this.modal_impresion_tarjetas_jugador.componentInstance.usuario = this.usuario;
    this.modal_impresion_tarjetas_jugador.componentInstance.equipo = equipo;
    for(let i=0;i<jugadores.length;i++){
      jugadores[i].equipo=equipo;
    }
    this.modal_impresion_tarjetas_jugador.componentInstance.impresion_tarjetas_jugador.lista_jugadores =jugadores;
		
		this.modal_impresion_tarjetas_jugador.componentInstance.alTerminar.subscribe((res) => {
			this.modal_impresion_tarjetas_jugador.close();
		});
  }

  async generarTarjetaIdentificacion(jugadores_seleccionados,equipo){
    jugadores_seleccionados=this.orderPipe.transform(jugadores_seleccionados, 'jugador.persona.nombre_completo',false);
      for(let i=0;i<jugadores_seleccionados.length;i++){
        jugadores_seleccionados[i].equipo=equipo;
      }
      var doc = new PDFDocument({layout:'landscape',margin:0,size:GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA});
      var stream = doc.pipe(blobStream());
      let canvas:any=document.getElementById('qr-code');
      // draw some text
      doc.fontSize(8);
      var yCard=20,items=0,page=1,carnets_por_hoja=8,x_c=45;
      let fecha_inicio=new Date();
      let fecha_fin=new Date();
      fecha_fin.setDate(fecha_inicio.getDate()+365-1);
      for(var i=0;i<jugadores_seleccionados.length;i++){
        doc.switchToPage(page-1);
        items++;
        let campeonato=jugadores_seleccionados[i].equipo.campeonato;
        //Carnet Cara Principal
        doc.rect(x_c, yCard, 227, 142).fill(campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta);
        let logo=await Util.convertirUrlToBase64Image(this.rest_server+campeonato.logo);
        doc.image(logo,x_c+170,yCard,{width: 50});
        doc.fillColor('white');
        doc.font('Helvetica-Bold',11);
        if(campeonato.configuracion_tarjeta_jugador.campeonato_propio){
          doc.text(this.usuario.empresa.nombre,x_c+10,yCard+10,{width:150});
        }else{
          doc.fillColor(campeonato.configuracion_tarjeta_jugador.datos_color);
          doc.text(campeonato.nombre.toUpperCase(),x_c+10,yCard+10,{width:150});
        }
        doc.font('Helvetica-Bold',10);
  
        doc.fillColor(campeonato.configuracion_tarjeta_jugador.titulo_color_jugador);
        doc.text("TARJETA DE JUGADOR",x_c+30,yCard+42);
        doc.fontSize(8);
        doc.fillColor(campeonato.configuracion_tarjeta_jugador.enunciados_color);
        doc.text("NOMBRE:",x_c+80,yCard+55);
        doc.text("EQUIPO:",x_c+80,yCard+75);
        doc.text("CATEGORIA:",x_c+80,yCard+115);
        doc.text("DISCIPLINA:",x_c+80,yCard+125);
        doc.text("TORNEO:",x_c+80,yCard+95);
        doc.fontSize(8);
        doc.fillColor(campeonato.configuracion_tarjeta_jugador.datos_color);
        let imagen_persona=await Util.convertirUrlToBase64Image(GlobalVariable.SERVER_URL+jugadores_seleccionados[i].jugador.persona.imagen);
        doc.image(imagen_persona,x_c+9,(yCard+60),{width: 70,height:70});
        doc.text(jugadores_seleccionados[i].jugador.persona.nombre_completo.toUpperCase(),x_c+118,yCard+55,{width:100});
        doc.text((equipo?equipo.nombre:jugadores_seleccionados[i].equipo.nombre),x_c+118,yCard+75,{width:100});
        doc.text((equipo?equipo.categoria.nombre:jugadores_seleccionados[i].equipo.categoria.nombre),x_c+130,yCard+115,{width:100});
        doc.text((equipo?equipo.disciplina.nombre:jugadores_seleccionados[i].equipo.disciplina.nombre),x_c+130,yCard+125,{width:100});
        doc.text(campeonato.nombre.toUpperCase(),x_c+118,yCard+95,{width:100});
        doc.rect(x_c+9, yCard+125, 70,5).fill(campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta);
        doc.fillColor(campeonato.configuracion_tarjeta_jugador.enunciados_color);
        doc.fontSize(7);
        let texto_carnet=jugadores_seleccionados[i].jugador.persona.ci?jugadores_seleccionados[i].jugador.persona.ci:"";
        let fecha_nacimiento:any=jugadores_seleccionados[i].jugador.persona.fecha_nacimiento?new Date(jugadores_seleccionados[i].jugador.persona.fecha_nacimiento):null;
        texto_carnet=texto_carnet+(fecha_nacimiento?" "+(fecha_nacimiento.getDate()+"/"+(fecha_nacimiento.getMonth()+1)+"/"+fecha_nacimiento.getFullYear()):"");
        doc.text(texto_carnet,x_c+9,yCard+126,{width:70,align:'center'});
        
        //Carnet Cara trasera
        doc.rect(x_c+228, yCard, 227, 142).fillAndStroke("#ffffff","#000000");
        qr.canvas({
          canvas: canvas,
          value: jugadores_seleccionados[i].jugador.codigo
        },function(){console.log("created");});
        var qrImage=canvas.toDataURL('image/png');
        doc.image(qrImage,x_c+360,(yCard+5),{width: 70});	
        //doc.rect(295, yCard+16, 155,85).fillAndStroke("yellow", "#900");
        doc.fillColor('black');
        doc.fontSize(9);
        doc.text("¡Cuanto más dificil es la victoria, mayor es la felicidad de ganar!",x_c+240,yCard+10,{width:125});
        doc.fontSize(6);
        doc.text("-------------------------------------------",x_c+240,yCard+110);
        doc.text("JUGADOR",x_c+240,yCard+120,{width:80,align:"center"});
        doc.text("-------------------------------------------",x_c+340,yCard+110);
        if(campeonato.configuracion_pdf_rol_partido.campeonato_propio){
          doc.text("L.D.C.M. ORGANIZACIÓN",x_c+340,yCard+120,{width:80,align:"center"});
        }else{
          doc.text("ORGANIZACIÓN",x_c+340,yCard+120,{width:80,align:"center"});
        }

        let firma=await Util.convertirUrlToBase64Image(this.rest_server+"img/firma-organizacion.png");
        doc.image(firma,x_c+340,(yCard+70),{width: 100});
  
        if(items%2==0){
          yCard=yCard+143;
          x_c=45;
        }else{
          yCard=yCard;
          x_c=x_c+228*2;
        }
        
        if(items==carnets_por_hoja){
          items=0;
          yCard=20;
          doc.addPage({layout:'landscape',margin:0,size:GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA});
          page++;
        }
      }
      
      doc.end();
  
      stream.on('finish', function () {
        var fileURL = stream.toBlobURL('application/pdf');
        var w = window.open(fileURL, '_blank', 'location=no');
        setTimeout(function () {
          w.print();
        }, 500);
      });
    }

  
}
